import { GoldExpSystem } from '../../domain/goldExpSystem.js';

/**
 * Awards shared nearby XP for dead minions once (simulation path — not presentation).
 * @returns {number} how many victims were processed this call
 */
export function processDeadMinionNearbyExp({
  activeMinions = [],
  champions = [],
  radius = 8.0
} = {}) {
  let processed = 0;
  for (const entry of activeMinions) {
    const victim = entry?.domain;
    if (!victim || !victim.isDead) continue;
    if (victim.nearbyExpProcessed) continue;
    GoldExpSystem.awardNearbyExp(champions, victim, radius);
    victim.nearbyExpProcessed = true;
    processed += 1;
  }
  return processed;
}
